import React, { memo } from "react";
import { Link } from "react-router-dom";
import { getDiscount } from "../../../utils/functions";

// Memoizing the Product component to prevent unnecessary re-renders
const Product = memo((props) => {
  const { _id, name, images, price, cuttedPrice } = props;

  // Truncating name (if necessary) - avoid recomputation on every render
  const truncatedName = name.length > 50 ? `${name.substring(0, 50)}...` : name;

  const hasDiscount = cuttedPrice > price;
  const discountPercentage = hasDiscount ? getDiscount(price, cuttedPrice) : null;

  return (
    <div className="group flex flex-col items-center px-4 py-4 bg-white shadow-md hover:shadow-lg rounded-lg relative transition-shadow duration-300 flex-1">
      <Link
        to={`/product/${_id}`}
        className="flex flex-col items-center text-center group h-full"
      >
        {/* Image */}
        <div className="w-40 h-40 md:w-52 md:h-52 overflow-hidden rounded-lg transition-transform duration-300 transform group-hover:scale-105 mb-3">
          <img
            draggable="false"
            className="w-full h-full object-contain"
            src={images[0].url}
            alt={name}
            loading="lazy"  // Lazy loading for images
          />
        </div>

        {/* Product Title */}
        <h2 className="text-sm md:text-base font-semibold text-gray-800 group-hover:text-primary-blue transition-colors duration-300 mb-2">
          {truncatedName}
        </h2>

        {/* Price Section */}
        <div className="flex items-baseline gap-2 sm:gap-4 text-lg font-semibold text-gray-800 mt-auto">
          <span className="text-xl font-bold text-gray-900">
            ₹{price.toLocaleString()}
          </span>

          {hasDiscount && (
            <>
              <span className="text-sm text-gray-500 line-through">
                ₹{cuttedPrice.toLocaleString()}
              </span>
              <span className="text-sm text-primary-green font-semibold">
                {discountPercentage}% OFF
              </span>
            </>
          )}
        </div>
      </Link>
    </div>
  );
});

export default Product;
